import { BaseSidebarObject } from '@y42/gojs';
import { IZOrderableNode } from '../../common/models/node.interfaces';

export class ImageNode extends BaseSidebarObject implements IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public source = '',
    public location = '0 0',
    public size = 'NaN NaN',
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
